import { defineConfig } from '@chakra-ui/react';

import { recipes } from './recipes';
import { slotRecipes } from './slot-recipes';
import { textStyles } from './textStyles';
import { tokens } from './tokens';

export const webDesignSystemConfig = defineConfig({
	theme: {
		recipes,
		slotRecipes,
		textStyles,
		tokens,
	},
});
